
console.log("TEST DEBUG")
class ProductCardCarousel extends HTMLElement {
  constructor() {
    super();
    console.log("TEST DEBUG 3")
    this.currentIndex = 0;
    this.isTransitioning = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.isScrolling = undefined;
    this.swipeEnabled = false; // Set to true to enable swipe
  }

  connectedCallback() {
    this.initializeCarousel();
  }

  get slidesContainer() {
    return this.querySelector('.product-card-carousel__slides');
  }

  get slides() {
    return this.querySelectorAll('.product-card-carousel__slide');
  }

  get prevButton() {
    return this.querySelector('.product-card-carousel__prev');
  }

  get nextButton() {
    return this.querySelector('.product-card-carousel__next');
  }

  initializeCarousel() {
    const slides = this.slides;
    if (slides.length <= 1) {
      // Hide navigation if only one slide
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
      return;
    }

    // Set up navigation buttons
    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.prevSlide();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.nextSlide();
      });
    }

    // Set up touch/swipe events (only if enabled)
    if (this.swipeEnabled) {
      this.slidesContainer.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
      this.slidesContainer.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      this.slidesContainer.addEventListener('touchend', this.handleTouchEnd.bind(this));
    }

    // Initialize first slide
    this.updateCarousel();
  }

  updateCarousel() {
    const slides = this.slides;
    const currentIndex = this.currentIndex;

    // Move ALL slides together by the same amount
    const translateValue = -currentIndex * 100;
    slides.forEach((slide) => {
      slide.style.transform = `translateX(${translateValue}%)`;
    });

    // Update progress indicator
    this.updateProgressIndicator();

    // Buttons are never disabled for infinite loop
    if (this.prevButton) {
      this.prevButton.disabled = false;
      this.prevButton.setAttribute('aria-disabled', 'false');
    }

    if (this.nextButton) {
      this.nextButton.disabled = false;
      this.nextButton.setAttribute('aria-disabled', 'false');
    }
  }

  updateProgressIndicator() {
    const indicator = this.querySelector('.product-card-carousel__progress-indicator');
    if (indicator) {
      const progressPercentage = (this.currentIndex) * 100;
      indicator.style.transform = `translateX(${progressPercentage}%)`;
    }
  }

  goToSlide(index) {
    const slides = this.slides;
    if (this.isTransitioning) return;

    // Handle infinite loop
    let newIndex = index;
    if (index < 0) {
      newIndex = slides.length - 1;
    } else if (index >= slides.length) {
      newIndex = 0;
    }

    this.isTransitioning = true;
    this.currentIndex = newIndex;
    this.updateCarousel();

    setTimeout(() => {
      this.isTransitioning = false;
    }, 300);
  }

  nextSlide() {
    this.goToSlide(this.currentIndex + 1);
  }

  prevSlide() {
    this.goToSlide(this.currentIndex - 1);
  }

  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchStartY = e.touches[0].clientY;
    this.isScrolling = undefined;
  }

  handleTouchMove(e) {
    if (!this.touchStartX || !this.touchStartY) {
      return;
    }

    this.touchEndX = e.touches[0].clientX;
    this.touchEndY = e.touches[0].clientY;

    // Determine if scrolling horizontally or vertically
    if (typeof this.isScrolling === 'undefined') {
      const diffX = Math.abs(this.touchStartX - this.touchEndX);
      const diffY = Math.abs(this.touchStartY - this.touchEndY);
      this.isScrolling = diffY > diffX;
    }

    // If horizontally scrolling, prevent default to stop page scroll
    if (!this.isScrolling) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  handleTouchEnd(e) {
    if (!this.isScrolling) {
      this.handleSwipe();
    }
    // Reset values
    this.touchStartX = null;
    this.touchStartY = null;
    this.isScrolling = undefined;
  }

  handleSwipe() {
    const swipeThreshold = 30;
    const diff = this.touchStartX - this.touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        this.nextSlide();
      } else {
        // Swipe right - prev slide
        this.prevSlide();
      }
    }
  }
}


console.log("TEST DEBUG 2", customElements.get('product-card-carousel'))
// Register the custom element
if (!customElements.get('product-card-carousel')) {
  customElements.define('product-card-carousel', ProductCardCarousel);
}